import HomeScreenState from "./HomeScreenState";

export default class AppState {

    constructor() {
        this.houseOpen      = false;
        this.homeState      = new HomeScreenState();
        this.storylines     = null;
        this.storylineState = null;
    }

    get showHouse() {
        return this.houseOpen === true;
    }
}
